import { Spacing } from '@persona-id/design-tokens';
import { ReactElement, VFC } from 'react';
import styled from 'styled-components';

import HelpIcon from 'dashboard/components-lib/HelpIcon';
import { HStack } from 'design-system/components/Stack';
import { Label, LabelProps } from 'design-system/components/Text';
import { ParagraphSize } from 'design-system/mixins/text';

interface ParamLabel {
  labelText: string;
  htmlFor?: string;
  helpText?: string;
  id?: string;
  size?: ParagraphSize;
  weight?: LabelProps['weight'];
  buttons?: ReactElement[];
}

const Row = styled.div<{ bottom: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${Spacing[2]};
  align-items: center;
`;

const LabelAndHelp = styled.div`
  display: flex;
`;

const HelpIconWithMinimumHeight = styled(HelpIcon)`
  line-height: initial;
`;

const ParamLabel: VFC<ParamLabel> = ({
  labelText,
  helpText,
  htmlFor,
  id,
  buttons = [],
  size = 'md',
  weight = 'bold',
}) => {
  return (
    <Row bottom={buttons.length > 0}>
      <LabelAndHelp>
        <Label htmlFor={htmlFor} size={size} id={id} weight={weight}>
          {labelText}
        </Label>
        {helpText && <HelpIconWithMinimumHeight>{helpText}</HelpIconWithMinimumHeight>}
      </LabelAndHelp>
      {buttons.length > 0 && <HStack>{buttons}</HStack>}
    </Row>
  );
};

export default ParamLabel;
